import { useState, useEffect } from "react";

import { useAlert } from "react-alert";

import { API_URL } from "../../../Constents";

const NationalHolidayList = () => {
  const [nationalHolidayList, setnationalHolidayList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const alert = useAlert();

  const fetehnationalHolidayList = async () => {
    const userData = JSON.parse(window.sessionStorage.getItem("user"));
    const headersList = {
      Authorization: "Token " + userData.seucrity_token,
    };

    const url = API_URL + "/add-fetch-public-holiday/";

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headersList,
      });

      const data = await response.json();
      console.log(data);
      setnationalHolidayList(data.data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert.error("There is an error in fetching Holiday list");
      setIsLoading(true);
    }
  };

  useEffect(() => {
    fetehnationalHolidayList();
  }, []);

  return (
    <>
      {isLoading === true ? (
        <p>Loading...</p>
      ) : nationalHolidayList.length === 0 ? (
        <h3>No Holiday Added</h3>
      ) : (
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Date</th>
              <th scope="col">Holiday</th>
            </tr>
          </thead>
          <tbody>
            {nationalHolidayList.map((list, index) => (
              <tr>
                <th scope="row">{index + 1}</th>
                <td>{list.date}</td>
                <td>{list.holiday_name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default NationalHolidayList;
